import { useCallback, useState } from 'react'
import { gql, useMutation } from '@apollo/client'
import validate from './validation'
export default (onSuccess, onError) => {
  const [mutation, { data, error, loading }] = useMutation(
    gql`mutation ($countryServiceRateInput: CountryServiceRateInput!, $countryId: ID!) {
        setServiceRateToCountry(countryServiceRateInput: $countryServiceRateInput, countryId: $countryId) {
          id
          name
          code
          dialCode
          defaultStudentRate
          createdAt
          updatedAt
          servicesRate {
            serviceId
            name
            defaultRate
          }
        }
    }`
  )
  const [validationErrors, setValidationErrors] = useState({})
  const submit = useCallback((obj) => {
    const errors = validate(obj)
    if (errors && Object.keys(errors).length) {
      setValidationErrors(errors)
      onError('validation Error')
      return
    }
    mutation({ variables: obj }).then((result) => {
      onSuccess(result)
    }).catch((e) => {
      setValidationErrors({ general: 'misc.apiError' })
      onError(e)
    })
  }, [mutation, onSuccess, onError])
  return { loading, data: data ? data.setServiceRateToCountry : null, error, validationErrors, submit }
}
